import { Text, TextLink } from '@cinch-labs/design-system'
import Link from 'next/link'

import styles from './keyword-list.module.css'

export interface Props {
  items: string[]
}

export const KeywordList: React.FC<Props> = ({ items }) => (
  <div className={styles.keywords} data-testid="jargon-keywords">
    <Text className={styles.header}>Keywords</Text>
    <ul className={styles.list}>
      {items &&
        items.map((keyword, index) => (
          <li className={styles.item} key={index}>
            <Link href={`/jargon?q=${keyword}`} passHref legacyBehavior>
              <TextLink className={styles.link}>{keyword}</TextLink>
            </Link>
          </li>
        ))}
    </ul>
  </div>
)
